import React, { useEffect, useRef, useState } from "react";
import PinIcon from "../../../assets/icons/markers/here.png"

const TmapGeocoder = ({ address, onGeocode, mapId }) => {
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [result, setResult] = useState("");
  const tmapAppKey = process.env.REACT_APP_TMAP_API_KEY;

  useEffect(() => {
    if (!window.Tmapv2) return;

    const mapInstance = new window.Tmapv2.Map(mapId, {
      center: new window.Tmapv2.LatLng(37.556032, 126.972191),
      width: "100%",
      height: "250px",
      zoom: 13,
      zoomControl: true,
      scrollwheel: true,
    });
    setMap(mapInstance);
  }, []);

  useEffect(() => {
    if (!map || !address) return;
    const fetchCoords = async () => {
      try {
        const response = await fetch(
          `https://apis.openapi.sk.com/tmap/geo/fullAddrGeo?version=1&format=json&coordType=WGS84GEO&fullAddr=${encodeURIComponent(address)}`,
          {
            method: "GET",
            headers: {
              appKey: tmapAppKey,
            },
          }
        );

        const data = await response.json();
        const coordinate = data.coordinateInfo?.coordinate?.[0];
        if (!coordinate) {
          setResult("요청 데이터가 올바르지 않습니다.");
          return;
        }

        const lat = coordinate.lat || coordinate.newLat;
        const lon = coordinate.lon || coordinate.newLon;

        if (onGeocode) {
          onGeocode({lat, lon});
        }
        if (marker) marker.setMap(null); // 기존 마커 제거

        const newMarker = new window.Tmapv2.Marker({
          position: new window.Tmapv2.LatLng(Number(lat), Number(lon)),
          icon: PinIcon,
          iconSize: new window.Tmapv2.Size(60, 60),
          map: map,
        });

        setMarker(newMarker);
        map.setCenter(new window.Tmapv2.LatLng(Number(lat), Number(lon)));
        setResult(`위경도: ${lat}, ${lon}`);
      } catch (err) {
        console.error(err);
        map.setCenter(new window.Tmapv2.LatLng(37.570028, 126.986072));
        setResult("검색 중 오류 발생");
      }
    };

    fetchCoords();
  }, [map, address]);

  return (
    <div className="w-full h-[250px] relative px-[10px]">
      <div
        id={mapId}
        ref={mapRef}
        className="w-full h-full"
        style={{ marginTop: "10px" }}
      />
    </div>
  );
};

export default TmapGeocoder;